import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import {CarouselDisplay, CatalogRecordService} from '@raven';
import {CatalogRecordSearchTarget} from '../../model/catalog-search/catalog-record-search-target';

@Component({
  selector: 'rn-catalog-home',
  templateUrl: './catalog-home.component.html',
  styleUrl: './catalog-home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CatalogHomeComponent implements OnInit {
  protected loadingSubject = new BehaviorSubject<boolean>(true);
  public loading$ = this.loadingSubject.asObservable();
  searchForm: FormGroup;
  carouselDisplays: CarouselDisplay[] = [];


  constructor(private fb: FormBuilder,
              private router: Router,
              public dialog: MatDialog,
              public catalogRecordService: CatalogRecordService) {
  }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchTarget: ['KEYWORD' as CatalogRecordSearchTarget, {validators: []}],
      searchTerm: ['', {validators: []}],
    });
    this.catalogRecordService.getCarouselDisplays().pipe(
      tap((result) => {
        this.carouselDisplays = result;
      }),
      finalize(() => this.loadingSubject.next(false)))
      .subscribe();
  }

  doSearch(): void {
    this.router.navigate([`/catalog-browse`],
      {queryParams: {'searchTarget': this.searchForm.value.searchTarget, 'query': this.searchForm.value.searchTerm},});
  }
}
